<template>
  <div v-if="APIType === OAPI_API_TYPE && activeVendor.pickupTimeSelectionEnabled" class="selected-pickup iw-layout-grid">
    <div class="iw-layout-grid__row">
      <div class="selected-pickup__col theme-group-3 iw-layout-grid__col--span-12" @click="updatePickup">
        <div class="selected-pickup__wrapper">
          <span class="selected-pickup__clock">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              focusable="false"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </span>

          <button class="selected-pickup__time">
            {{ selectedPickupOption }}
          </button>
          <span class="selected-pickup__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="4" height="9" viewBox="0 0 4 9">
              <g fill="none" fill-rule="evenodd">
                <g stroke="currentColor" stroke-width="1.5">
                  <path d="M0 0L3.968 4.353 0 8.197" transform="translate(-182 -148) translate(182 148)" />
                </g>
              </g>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pickupTimeMixin from "@/mixins/pickup-time.mixin";
import { showDialog, OAPI_API_TYPE } from "@/utils";
import { ERROR_PICK_UP_TIME_SELECTED_NOT_AVAILABLE } from "@/../app-constants";

export default {
  name: "SelectedPickupTime",
  mixins: [pickupTimeMixin],
  props: {
    openOnMount: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      getVenueInfo: "venue/getVenueInfo",
      getValidPickupTimes: "vendor/getValidPickupTimesByVendorId"
    })
  },
  watch: {
    errorMessage: function() {
      if (this.errorMessage) {
        this.showPickupTimeOptions(this.activeVendor.id, { errorMessage: this.errorMessage });
      }
    }
  },
  mounted: function() {
    if (this.openOnMount) {
      this.updatePickup();
    }
  },
  created() {
    this.OAPI_API_TYPE = OAPI_API_TYPE;
  },
  methods: {
    updatePickup() {
      if (!this.activeVendor.pickupTimeSelectionEnabled) {
        showDialog(this, "", ERROR_PICK_UP_TIME_SELECTED_NOT_AVAILABLE);
        return;
      }
      this.showPickupTimeOptions(this.activeVendor.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.selected-pickup {
  width: 100%;

  &__col {
    cursor: pointer;
    border-radius: 5px;
  }

  &__wrapper {
    align-items: center;
    color: $group-3-color-3;
    display: flex;
    line-height: 30px;
    padding-left: $spacer;
  }

  &__time {
    background: transparent;
    border: none;
    color: $group-3-color-2;
    font-family: inherit;
    font-size: inherit;
    margin: 0 ($spacer * 0.5);
  }

  &__icon {
    color: $group-3-color-4;
  }
  &__clock {
    svg {
      line-height: 1em;
      vertical-align: middle;
      fill: none;
      stroke: currentcolor;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
}
</style>
